import { Head, router, useForm, usePage } from "@inertiajs/react"

import { JobForm, type JobFormData } from "@/components/jobs/job-form"
import AppLayout from "@/layouts/app-layout"
import { jobPath } from "@/routes"

interface Job {
  id: number | string
  title: string
  company_name: string
  location_type?: string
  category?: string
  apply_url?: string
  apply_instructions?: string
  status: string
  description: string
}

export default function JobsEdit() {
  const page = usePage<{ job: Job }>()
  const { job } = page.props

  const { data, setData, patch, processing, errors } = useForm<JobFormData>({
    title: job.title ?? "",
    company_name: job.company_name ?? "",
    category: job.category ?? "tech",
    location_type: job.location_type ?? "onsite",
    apply_url: job.apply_url ?? "",
    apply_instructions: job.apply_instructions ?? "",
    description: job.description ?? "",
    status: job.status ?? "active",
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(jobPath(job.id), {
      forceFormData: true,
    })
  }

  return (
    <AppLayout>
      <Head title={`Editar - ${job.title}`} />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <JobForm
          title="Editar curro"
          data={data}
          errors={errors as Record<string, string>}
          processing={processing}
          onChange={(partial) => {
            Object.entries(partial).forEach(([key, value]) => {
              setData(key as keyof JobFormData, value)
            })
          }}
          onSubmit={handleSubmit}
          onCancel={() => router.visit(jobPath(job.id))}
          submitLabel="Guardar cambios"
        />
      </div>
    </AppLayout>
  )
}
